import React, { createContext, useContext, useMemo, useCallback } from "react";
import mx from "@/locales/mx.json";
import en from "@/locales/en.json";

const dictionaries = { mx, en };

const I18nContext = createContext({
  lang: "mx",
  t: (key) => key,
  setLang: () => {},
});

function resolve(obj, key) {
  return key.split(".").reduce((acc, part) => {
    if (acc && typeof acc === "object" && part in acc) return acc[part];
    return undefined;
  }, obj);
}

export const I18nProvider = ({ lang, children }) => {
  const active = dictionaries[lang] || dictionaries.mx;

  const t = useCallback(
    (key) => {
      const value = resolve(active, key);
      if (typeof value === "string") return value;
      return key;
    },
    [active]
  );

  const value = useMemo(() => ({ lang, t }), [lang, t]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useT = () => useContext(I18nContext);
